import React from 'react';
import styles from './NewsCard.module.scss'
import { Link } from "react-router-dom";
import { ISODateToSpanish } from '../../utilities/dateFormatter';

const NewsCard = ({ newsItem, onOpen }) => {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.imageContainer}>
        <img className={styles.cardImage} src={newsItem.mainImage} alt={newsItem.title} />
      </div>
      <div className={styles.cardBody}>
        {newsItem.category?.name && <span className={styles.category}>{newsItem.category.name}</span>}
        
        <Link onClick={() => onOpen(newsItem.id)} className={styles.cardLink}>
          <h3 className={styles.cardTitle}>{newsItem.title}</h3>
        </Link>
        
        <p className={styles.cardDescription}>{newsItem.description}</p>
        
        <div className={styles.infoRow}>
          <div className={styles.authorCircle} />
          <div className={styles.authorInfo}>
            {newsItem.author && <span className={styles.author}>{newsItem.author}</span>}
            {newsItem.createdAt && <span className={styles.dateText}>{ISODateToSpanish(newsItem.createdAt)}</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;